import { UpsertMembershipTypeRequest } from '@/apiClient/api';
import { usePrivate } from '@/components/private';
import { ERecordStatus, TMembershipType } from '@/model/configuration';
import useSWRMutation from 'swr/mutation';

const getUpsertMembershipTypeCachedKey = () => ['/api/MembershipType/Bulk'];

export const useUpsertMembershipType = () => {
  const { membershipTypeApi, selectedOrganisationId } = usePrivate();
  const path =
    selectedOrganisationId && membershipTypeApi
      ? getUpsertMembershipTypeCachedKey()
      : null;

  const { data, trigger, isMutating } = useSWRMutation(
    path,
    (key, { arg }: { arg: UpsertMembershipTypeRequest }) =>
      membershipTypeApi?.apiMembershipTypeBulkPost(arg),
  );

  const transformValueToUpsertPayload = (
    arg: TMembershipType[],
  ): UpsertMembershipTypeRequest => {
    return {
      organisationId: selectedOrganisationId!,
      membershipTypes: arg.map((member) => ({
        ...member,
        annualPrice: Number(member.annualPrice),
        recordStatus: member.recordStatus,
      })),
    };
  };

  return {
    data,
    trigger,
    isLoading: isMutating,
    transformValueToUpsertPayload,
  };
};
